import { useCallback, useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { useProductTypeSearchParam } from '../../hooks/useProductTypeSearchParams';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useSearchResultsPagination } from './useSearchResultsPagination';
export function useSearchResultsCanonicalPaths() {
  const productType = useProductTypeSearchParam();
  const searchParams = useSearchParams();
  const {
    currentPage,
    pageCount
  } = useSearchResultsPagination();
  const {
    AgentTeam,
    Category
  } = useFilterConfig();
  const getCanonicalPaths = useCallback((rootPath, pagePath, routeParams = {}) => {
    return {
      current: currentPage > 1 ? generatePath(pagePath, Object.assign({
        page: currentPage
      }, routeParams)) : generatePath(rootPath, routeParams),
      next: currentPage < pageCount ? generatePath(pagePath, Object.assign({
        page: currentPage + 1
      }, routeParams)) : undefined,
      previous: currentPage > 2 ? generatePath(pagePath, Object.assign({
        page: currentPage - 1
      }, routeParams)) : currentPage === 2 ? generatePath(rootPath, routeParams) : undefined
    };
  }, [currentPage, pageCount]);
  return useMemo(() => {
    if (productType === 'APP') {
      const categoryValues = Category ? searchParams.getList(Category.field) : [];
      if (categoryValues.length === 1) {
        const categoryOption = Category === null || Category === void 0 ? void 0 : Category.options.find(option => option.value === categoryValues[0]);
        if (categoryOption && categoryOption.slug) {
          return getCanonicalPaths(Paths.APPS_CATEGORY, Paths.APPS_CATEGORY_PAGE, {
            categorySlug: categoryOption.slug
          });
        }
      }
      return getCanonicalPaths(Paths.APPS_ALL, Paths.APPS_ALL_PAGE);
    }
    if (productType === 'AGENT') {
      const agentTeamValues = AgentTeam ? searchParams.getList(AgentTeam.field) : [];
      if (agentTeamValues.length === 1) {
        const agentTeamOption = AgentTeam === null || AgentTeam === void 0 ? void 0 : AgentTeam.options.find(option => option.value === agentTeamValues[0]);
        if (agentTeamOption && agentTeamOption.slug) {
          return getCanonicalPaths(Paths.AGENTS_TEAM, Paths.AGENTS_TEAM_PAGE, {
            teamSlug: agentTeamOption.slug
          });
        }
      }
      return getCanonicalPaths(Paths.AGENTS_ALL, Paths.AGENTS_ALL_PAGE);
    }
    return getCanonicalPaths(Paths.SEARCH_RESULTS, Paths.SEARCH_RESULTS_PAGE);
  }, [AgentTeam, Category, getCanonicalPaths, productType, searchParams]);
}